import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

import logo from "../../images/logo.svg";
import shoppingCartIcon from "../../images/icons/shopping-cart.svg";

import "../../css/header.css";

const Header = (props) => {
    const [resources, setResources] = useState({});

    let navigate = useNavigate();
    const { language } = useParams();

    let languageNavPath = props.pagePath || "home";

    let eventId = props.eventId;
    let orderId = props.orderId;

    useEffect(() => {
        requestResources();
    }, [language]);

    const requestResources = async () => {
        try {
            const res = await axios.get(`form/resources/${language}`);
            setResources(res.data?.translation);
        } catch (error) {
            console.error(error?.response?.data);
        }
    };

    const handleLanguageSwitch = (lang) => {
        if (lang === language) return;

        if (languageNavPath === "home") {
            navigate(`/${lang}/home/${eventId}`);
        } else if (languageNavPath === "confirmation") {
            navigate(orderId ? `/${lang}/confirmation/${orderId}` : `/${lang}/confirmation`);
        } else {
            navigate(`/${lang}/${languageNavPath}`);
        }
    };

    const LanguageSwitch = () => {
        return (
            <div className="d-flex align-items-center language-switch">
                <span
                    className={`language-switch-option ${language === "de" ? "active" : ""}`}
                    onClick={() => handleLanguageSwitch("de")}
                >
                    DE
                </span>
                <span className="language-switch-divider">/</span>
                <span
                    className={`language-switch-option ${language === "en" ? "active" : ""}`}
                    onClick={() => handleLanguageSwitch("en")}
                >
                    EN
                </span>
            </div>
        );
    };

    const ShopbasketIcon = () => {
        return (
            props.isShoppingCartVisible && (
                <div className="d-flex align-items-center justify-content-end">
                    <div
                        className={`nav-shop-basket-container ${props.numberOfTickets > 0 ? 'cursor-pointer' : ''}`}
                        onClick={props.numberOfTickets > 0 ? () => navigate(`/${language}/shipping`) : undefined}
                    >
                        <img src={shoppingCartIcon} alt="Shopping cart" className="nav-shop-basket" />
                    </div>
                    {props.numberOfTickets > 0 && (
                        <span className="cart-quantity">
                            {props.numberOfTickets}
                        </span>
                    )}
                </div>
            )
        );
    };


    return (
        <header className="header-stadt-zug container-fluid">
            <div className="container header-wrapper">
            <div className="row">

                {/* Left column */}
                <div className="col d-flex flex-column header-left align-items-start justify-content-start">

                    <div className="d-flex align-items-center mb-2" style={{ width: "100%" }} >

                        {/* Logo desktop */}
                        <a href={resources?._StadtZugUrl} className="visible-desktop">
                            <img src={logo} alt="Logo" className="logo" />
                        </a>

                        {/* Logo mobile */}
                        <a href={resources?._StadtZugUrl} className="visible-mobile">
                            <img src={logo} alt="Logo" className="logo" />
                        </a>

                        <div className="visible-mobile ms-auto d-flex align-items-center">
                            <LanguageSwitch />
                            {ShopbasketIcon()}
                        </div>
                    </div>
                </div>

                {/* Center column */}
                <div className="col d-flex flex-column text-center header-center justify-content-start">

                </div>

                {/* Right column */}
                <div className="visible-desktop col d-flex flex-column header-right align-items-end justify-content-start">

                    <div className="d-flex align-items-center justify-content-end mt-4 mb-2">
                        <LanguageSwitch />
                        {ShopbasketIcon()}
                    </div>
                </div>
            </div>
            </div>
        </header >
    );
};

export default Header;